import React from 'react';
import { X, Calendar, ExternalLink, Clock, Video, Shield, CheckCircle, Phone, Mail, ArrowRight } from 'lucide-react';

const MICROSOFT_BOOKINGS_URL = "https://outlook.office.com/bookwithme/user/fbf764a9bb5b4c9793065cc702e3b5e6%40getcare360.com.au/meetingtype/sFYthDfSHkCSVKjlKsBDsA2?anonymous&ismsaljsauthenabled";

const BookingModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const openBooking = () => {
    window.open(MICROSOFT_BOOKINGS_URL, '_blank');
  };

  const benefits = [
    { icon: Clock, text: "30-minute strategy session" },
    { icon: Video, text: "Video call via Microsoft Teams" },
    { icon: Shield, text: "No obligation, 100% free" },
    { icon: CheckCircle, text: "Personalised demo" }
  ];

  return (
    <div className="fixed inset-0 z-[9999] overflow-y-auto">
      {/* Overlay */}
      <div 
        className="fixed inset-0 bg-black/70"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative min-h-screen flex items-center justify-center p-4">
        <div 
          className="relative bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="bg-gradient-to-r from-slate-800 to-slate-900 px-5 py-4 flex items-center justify-between">
            <div className="flex items-center gap-3 text-white">
              <Calendar size={22} />
              <span className="font-semibold text-lg">Book Your Demo</span>
            </div>
            <button
              onClick={onClose}
              className="bg-white/20 hover:bg-white/30 text-white p-2 rounded-lg transition-colors"
              data-testid="booking-modal-close"
            >
              <X size={20} strokeWidth={2.5} />
            </button>
          </div>

          {/* Content */}
          <div className="p-6">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Calendar className="text-slate-700" size={32} />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">
                Schedule a Free Strategy Call
              </h3>
              <p className="text-gray-600">
                Book a 30-minute call with our NDIS software experts
              </p>
            </div>

            {/* Benefits */}
            <div className="bg-gray-50 rounded-lg p-4 mb-6">
              <div className="grid grid-cols-2 gap-3">
                {benefits.map((benefit, i) => (
                  <div key={i} className="flex items-center gap-2">
                    <benefit.icon size={16} className="text-teal-600 flex-shrink-0" />
                    <span className="text-sm text-gray-700">{benefit.text}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* CTA Button */}
            <button
              onClick={openBooking}
              className="w-full bg-gradient-to-r from-slate-800 to-slate-700 hover:from-slate-700 hover:to-slate-600 text-white font-bold py-4 rounded-lg flex items-center justify-center gap-2 transition-all mb-4"
            >
              <Calendar size={20} />
              Open Booking Calendar
              <ArrowRight size={20} />
            </button>

            {/* Contact Info */}
            <div className="text-center text-sm text-gray-500">
              <p className="mb-2">Or contact us directly:</p>
              <div className="flex justify-center gap-4">
                <a href="tel:1800951438" className="flex items-center gap-1 text-slate-700 hover:text-slate-900">
                  <Phone size={14} />
                  1800 951 GET
                </a>
                <a href="mailto:info@getcare360.com.au" className="flex items-center gap-1 text-slate-700 hover:text-slate-900">
                  <Mail size={14} />
                  Email Us
                </a>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="bg-gray-50 px-5 py-3 flex items-center justify-center gap-2 text-xs text-gray-500 border-t">
            <svg viewBox="0 0 23 23" className="w-4 h-4" fill="none">
              <path d="M11 11H0V0H11V11Z" fill="#F25022"/>
              <path d="M23 11H12V0H23V11Z" fill="#7FBA00"/>
              <path d="M11 23H0V12H11V23Z" fill="#00A4EF"/>
              <path d="M23 23H12V12H23V23Z" fill="#FFB900"/>
            </svg>
            <span>Powered by Microsoft Bookings</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingModal;
